import React from 'react';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface UnitFormProps {
  formMode: FormMode;
}

const UnitForm: React.FC<UnitFormProps> = ({ formMode }) => {
  return (
    <div className='space-y-3 p-4'>
      <div className='items-centere flex'>
        <Label className='w-40 min-w-40'>Đơn vị tính</Label>
        <FormField className='w-40' name='dvt' type='text' disabled={formMode === 'view'} />
      </div>

      <div className='items-centere flex'>
        <Label className='w-40 min-w-40'>Tên đơn vị tính</Label>
        <FormField className='w-40' name='ten_dvt' type='text' disabled={formMode === 'view'} />
      </div>

      <div className='items-centere flex'>
        <Label className='w-40 min-w-40'>Tên khác</Label>
        <FormField className='w-40' name='ten_khac' type='text' disabled={formMode === 'view'} />
      </div>

      <div className='items-centere flex'>
        <Label className='w-40 min-w-40'>Đơn vị tính 2</Label>
        <FormField className='w-40' name='dvt2' type='text' disabled={formMode === 'view'} />
      </div>

      <div className='items-centere flex'>
        <Label className='w-40 min-w-40'>Trạng thái</Label>
        <FormField
          className='w-40'
          name='status'
          type='select'
          options={[
            { label: '1. Còn sử dụng', value: 1 },
            { label: '0. Không sử dụng', value: 0 }
          ]}
          disabled={formMode === 'view'}
        />
      </div>
    </div>
  );
};

export default UnitForm;
